import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import ShowNameComponent from '../../Elements/ShowNameComponent';
import CurrencyService from '../../Services/CurrencyService';

export default class InPersonServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'Fieldwork',
      tabLabel: 'Fieldwork',
      icon: 'fa-solid fa-briefcase',
      data: [
        { name: (item) => JsxHelper.YesNo(item.InteractionRequired), label: 'Is Interaction Required?' },
        { name: 'ProductOrServiceInquiry', label: 'Product or Service Inquiry?' },
        { name: 'TimeConstraints', label: 'Visit Time Constraints (days/hours/etc)' },
        { name: (item) => <LookupText lookupId={37} value={item.MaxDeliveryAfterShop} />, label: 'Time to Deliver Evaluation to Client' },
        { name: (item) => Array.isArray(item.SpecialLocations) ? item.SpecialLocations.join(', ') : (item.SpecialLocations || ''), label: 'Special Locations' },
        { name: (item) => Array.isArray(item.LocationType) ? item.LocationType.join(', ') : (item.LocationType || ''), label: 'Location Type' },
        { name: 'LocationTypeDetails', label: 'Location Type Details', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'LocationListSource', label: 'Location List Source' },
        { name: '-', label: 'Reporting' },
        { name: (item) => Array.isArray(item.ReportingRequirements) ? item.ReportingRequirements.join(', ') : (item.ReportingRequirements || ''), label: 'Reporting Requirements' },
        { name: 'DetailedReportingRequirements', label: 'Detailed Reporting Requirements', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-', label: 'Evaluation Duration' },
        { name: (item) => dateTimeHelper.convertMinutesToDate(item.EvaluationDuration * 60), label: 'Evaluation Duration' },
      ],
    },
    {
      tabName: 'Questionnaire',
      tabLabel: 'Questionnaire',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.TranslationProvided), label: 'Translation of Questionnaire Provided by Client?' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
      ],
    },
    {
      tabName: 'PhoneCalls',
      tabLabel: 'Phone Calls',
      icon: 'fa-solid fa-phone',
      data: [
        { name: 'PrePostPhoneCall', label: 'Pre or Post Phone Call' },
        { name: (item) => JsxHelper.YesNo(item.PhoneCallsRequired), label: 'Are Phone Calls Required?' },
        { name: 'CallFlowDescription', label: 'Call Flow Description' },
        { name: (item) => JsxHelper.YesNo(item.CallerIdNeeded), label: "Does the Client's Phone Have Caller ID?" },
        { name: 'PhoneCallDescription', label: 'Description of Calls', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'NumCallsRecorded', label: 'No. of Recorded Calls per Evaluation' },
        { name: 'AvgVocazillaCallLength', label: 'Avg. Recorded Call Length (min) per Call' },
        { name: 'FollowUpPeriodExpected', label: 'Wait for Follow-up Period Expected' },
        { name: 'NumCallsNonRecorded', label: 'No. of Non-Recorded Calls per Evaluation' },
        { name: 'AvgNonRecordedCallLength', label: 'Avg. Non-Recorded Call Length (min) per Call' },
      ],
    },
    {
      tabName: 'Validation',
      tabLabel: 'Validation',
      icon: 'fa-solid fa-camera',
      data: [
        { name: 'NumPhotographsReqd', label: 'Number of Photographs Required' },
        { name: (item) => JsxHelper.YesNo(item.PhotosReqd), label: 'Storefront Photo Required?' },
        { name: 'OtherPhotosDesc', label: 'Describe other Photographs Required', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.ReceiptReqd), label: 'Receipt Required?' },
        { name: (item) => JsxHelper.YesNo(item.SoundRecordingReqd), label: 'Sound Recording Required?' },
        { name: (item) => JsxHelper.YesNo(item.VideoRecordingReqd), label: 'Video Recording Required?' },
        { name: (item) => <LookupText lookupId={35} value={item.OtherValidationReqd} />, label: 'Other Validation' },
      ],
    },
    {
      tabName: 'Purchase',
      tabLabel: 'Purchase',
      icon: 'fa-solid fa-cart-shopping',
      data: [
        { name: (item) => JsxHelper.YesNo(item.PurchaseReqd), label: 'Purchase Required?' },
        { name: (item) => JsxHelper.YesNo(item.ReceiptReqd), label: 'Receipt Required?' },
        { name: (item) => <ShowNameComponent serviceFunction={CurrencyService.GetCurrencyNameById} id={item.PurchaseAmtCurId} />, label: 'Purchase Amount Currency' },
        { name: 'PurchaseAmt', label: 'Minimum Purchase Amount' },
        { name: 'MaxPurchaseAmt', label: 'Maximum Purchase Amount' },
        { name: 'PurchaseDesc', label: 'Item Required to Be Purchased', width: TabListTableCellWidthEnum.TwoLines },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReimbursed), label: 'Purchase Reimbursed by Client?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseIncluded), label: 'Purchase NOT Reimbursed by BARE or Client?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReturned), label: 'Required Purchase to be Returned?' },
      ],
    },
    {
      tabName: 'Demographics',
      tabLabel: 'Demographics',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'MinAge', label: 'Minimum Age' },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: (item) => <LookupText lookupId={17} value={item.GenderCode} />, label: 'Gender' },
        { name: (item) => <LookupText lookupId={18} value={item.MaritalStatusCode} />, label: 'Marital Status' },
        { name: (item) => JsxHelper.YesNo(item.IsChildRequiredForVisit), label: 'Child Required for Visit' },
        { name: (item) => <LookupText lookupId={61} value={item.EvaluationType} />, label: 'Description of Additional Demographic Requirements' },
        { name: 'OtherQualifications', label: 'Other Demographic Requirements', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
